import $ from 'jquery';
import { setElementsFromScope, setRequired, setUniqNames } from "../../utilities/selectorHelpers";

export default function walmartConnectionTab(wizard) {
  const self = this;
  const el = wizard.getWizardElement();
  let connectionStatus = false;

  self.didNavigateToForm = function () {
    return connectionStatus;
  };

  let conId =  "";
  const retpartner = el.data("retailer-partners-info");
  const authenticateConnectionUrl = el.data("test-connection-url");
  const parName = el.data("par-name");
  let consumerIdPplaceholder = `Enter the Consumer ID provided by ${parName}`;
  let privateKeyPlaceholder = `Enter Private Key as avaliable in ${parName} Seller Center`;
  let privateKey;
  let consumerId;
  let elsPage = {};
  const elsMap = {
    authenticateConnectionBtn: "#authorizeConnectionBtn",
    privateKey: "#privateKey",
    consumerId: "#consumerId",
    description: "#description",
    loading: "#authenticateConnectionLoading",
    nextBtn: "#walmart-next-button",
    authenticateMsg: "#authenticateMsg",
    connNotAuth : ".conn-not-authorized",
    connAuth :".conn-authorized",
    connAuthDateTime : "#conn-auth-time"
  };

  self.areInputsValidForForm = function () {
    let privateKey1 = elsPage.privateKey.val();
    let consumerId1 = elsPage.consumerId.val();
    if(privateKey==privateKey1 && consumerId1==consumerId && connectionStatus==true){
      return connectionStatus;
    }else {
      elsPage.authenticateConnectionBtn.removeClass("hidden");
      elsPage.connAuth.hide();
      connectionStatus=false;
      return connectionStatus;
    }
  };

  self.init = function () {
    setElements();
    bindElements();
    setUniqNames([elsPage.privateKey, elsPage.consumerId]);
    setRequired([elsPage.privateKey, elsPage.consumerId]);
    onLoad();   
    populateEditForm(retpartner);
    elsPage.consumerId.attr('placeholder',consumerIdPplaceholder);
    elsPage.privateKey.attr('placeholder',privateKeyPlaceholder);
  };

  function onLoad() {
    elsPage.connNotAuth.hide();
    elsPage.connAuth.hide();
  }

  function populateEditForm(retpartner) {
    if (retpartner != null) {
      elsPage.description.val(retpartner.repDescription);
      elsPage.consumerId.val(retpartner.consumerId);
      elsPage.privateKey.val(retpartner.privateKey);
      elsPage.connAuthDateTime.val(retpartner.connAuthDateTime);
      if (retpartner.repConnectionTest =="1") {
        elsPage.authenticateConnectionBtn.addClass("hidden");
        privateKey = elsPage.privateKey.val();
        consumerId = elsPage.consumerId.val();
        elsPage.connAuth.text(getConnAuthText(retpartner.connAuthDate, retpartner.connAuthTime));
        elsPage.connAuth.show();
        connectionStatus = true;
      } else if (retpartner.repConnectionTest =="0") {
        connectionStatus = false;
      }
    }
  }

  function setElements() {
    setElementsFromScope(elsPage, elsMap, el);
  }

  function bindElements() {
    elsPage.authenticateConnectionBtn.on("click", authenticateBtnHandler);
  }

  // Validation
  function validateConnectionTab() {
    let isValid = false;
    let allPrevInputs = wizard.allPreviousFieldsUpToTargetForm(el.find(".configurations-tab"));

    if(wizard.areInputsValid(allPrevInputs, {displayErrors: true})){
      isValid = true;
    }

    return isValid;
  }

  function authenticateBtnHandler(e) {
    e.preventDefault();
    let isValid = validateConnectionTab();
    if (isValid) {
      elsPage.authenticateConnectionBtn.addClass("hidden");
      elsPage.loading.removeClass("hidden");
      privateKey = elsPage.privateKey.val();
      consumerId = elsPage.consumerId.val();
      $.ajax({
        url: authenticateConnectionUrl,
        type: "POST",
        dataType: "JSON",
        data: {
          privateKey: privateKey,
          consumerId: consumerId
        },
        success: onConnectionSuccess,
        error: onConnectionError
      });
    }
  }

  function onConnectionSuccess(data) {
    if(data.success) {
      connectionStatus = true;
      elsPage.loading.addClass("hidden");
      getAuthDateAndTime();
      elsPage.connAuth.show();
      elsPage.connNotAuth.hide();
    } else {
      onConnectionError(data);
    }
  }

  function onConnectionError(data) {
    connectionStatus = false;
    elsPage.loading.addClass("hidden");
    elsPage.connNotAuth.show();
    elsPage.authenticateConnectionBtn.removeClass("hidden");
  }

  function getAuthDateAndTime(){
    const date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    const strTime = hours + ':' + minutes + ' ' + ampm;
    elsPage.connAuth.text(getConnAuthText(date.toLocaleDateString(), strTime));
    elsPage.connAuthDateTime.val(`${date.toLocaleDateString()},${strTime}`);
  }

  function getConnAuthText(date, time) {
    return `Connection authorized: ${date} at ${time} Click 'Next' to review and activate this channel.`;
  }

 }



// WEBPACK FOOTER //
// ./src/pages/createChannel/walmartConnectionTab.js